export interface LogentriesEnvironment {
    logentries: {
        token: string;
        application: string;
    };
}
